/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import type {ReactNode} from 'react';

/**
 * Shared wrapper for the thin-stroke, currentColor glyphs used by the preset toolbar.
 * The foundation Icon set lacks working keys for these here, so the glyphs are drawn
 * inline. `stroke="currentColor"` is load-bearing — each glyph inherits its color from the
 * surrounding button's inline `color` style. Size differs per call site, so it is explicit.
 */
function StrokeGlyph({size, children}: {size: number; children: ReactNode}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {children}
      </g>
    </svg>
  );
}

/** Chevron pointing left (scroll-left arrow for single-line preset strip). */
export function ChevronLeftGlyph({size = 18}: {size?: number}) {
  return (
    <StrokeGlyph size={size}>
      <polyline points="15 19 8 12 15 5" />
    </StrokeGlyph>
  );
}

/** Chevron pointing right (mock `.views__arrow`). */
export function ChevronRightGlyph({size = 18}: {size?: number}) {
  return (
    <StrokeGlyph size={size}>
      <polyline points="9 5 16 12 9 19" />
    </StrokeGlyph>
  );
}

/** Chevron pointing down (mock `.views__all`). */
export function ChevronDownGlyph({size = 16}: {size?: number}) {
  return (
    <StrokeGlyph size={size}>
      <polyline points="5 9 12 16 19 9" />
    </StrokeGlyph>
  );
}

/** Plus / add glyph (mock `.view__add`). */
export function PlusGlyph({size = 16}: {size?: number}) {
  return (
    <StrokeGlyph size={size}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </StrokeGlyph>
  );
}
